<script>
import InputField from "@/components/input/InputField.vue";
import {reactive} from "vue";
import { helpers, required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import {api} from "@/modules/api"

export default {
  name: 'FormCategory',
  components: {InputField},
  setup() {
    const dataForm = reactive({
      label: '',
      icon: ''
    });

    const rules = {
      dataForm: {
        label: {required: helpers.withMessage('Ce champs est obligatoire', required)},
        icon: { required: helpers.withMessage('Ce champs est obligatoire', required) }
      }
    };

    const v$ = useVuelidate(rules, { dataForm })

    return { dataForm, v$ }
  },
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    submitData () {
      this.isLoading = true
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.isLoading = false
        return;
      }
      api.categories.create(this.dataForm).then(() => {
        this.emitter.emit('load-data', true)
        this.$emit('closeView')
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<template>
  <div>
    <div class="space-y-4">
      <input-field
          v-model="dataForm.label"
          label="Nom"
          :validation="v$.dataForm.label"
          placeholder="Bière.."
      />
      <input-field
          v-model="dataForm.icon"
          label="Icon"
          :validation="v$.dataForm.icon"
          placeholder="fa-solid fa-beer"
      />
      <a href="https://fontawesome.com/search?o=r&m=free" target="_blank">
        <div class="flex items-center p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
          <svg class="flex-shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <span class="sr-only">Info</span>
          <div>
            Retrouvez toutes les icônes possible ici.
          </div>
        </div>
      </a>
      <div class="bottom-0 left-0 flex justify-center w-full pb-4 space-x-4 md:px-4 md:absolute">
        <button @click="submitData"  class="text-white w-full justify-center bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
          Valider
        </button>
        <button @click="$emit('closeView')" class="inline-flex w-full justify-center text-gray-500 items-center bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">
          <svg aria-hidden="true" class="w-5 h-5 -ml-1 sm:mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>